<div class="custom-modal modal-selecao-volume">
  <div class="header">
    <h1 mat-dialog-title>
      <svg
        width="30"
        height="30"
        viewBox="0 0 26 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.490519 0H4.26834V0.981039H0.981039V3.54493H0V0.490519C0 0.220528 0.220528 0 0.490519 0ZM3.69332 3.34501H5.39571V16.655H3.69332V3.34501ZM14.3054 3.34501H15.5214V16.655H14.3054V3.34501ZM11.9497 3.34501H12.8607V16.655H11.9497V3.34501ZM6.84048 3.34501H7.35779V16.655H6.84048V3.34501ZM20.1134 3.34501H21.6323V16.655H20.1134V3.34501ZM16.9662 3.34501H18.6686V16.655H16.9662V3.34501ZM8.80256 3.34501H10.5049V16.655H8.80256V3.34501ZM0.981039 16.4551V19.019H4.26834V20H0.490519C0.220528 20 0 19.7815 0 19.5095V16.4551H0.981039ZM21.3108 0H24.8351C25.1051 0 25.3256 0.220528 25.3256 0.490519V3.54493H24.3446V0.981039H21.3108V0ZM25.3256 16.4551V19.5095C25.3256 19.7795 25.1051 20 24.8351 20H21.3108V19.019H24.3446V16.4551H25.3256Z"
          fill="black"
        />
      </svg>

      {{ codigoBarras }}
    </h1>
    <mat-icon mat-dialog-close="cancel">close</mat-icon>
  </div>
  <mat-divider></mat-divider>
  <div mat-dialog-content class="selecao-volume-content">
    <div
      *ngIf="isLoading"
      style="min-height: 120px"
      class="d-flex justify-content-center"
    >
      <mat-spinner color="primary" mode="indeterminate"></mat-spinner>
    </div>
    <div [hidden]="isLoading">
      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab label="Volumes encontrados" *ngIf="listaVolumes?.length">
          <div class="modal-content">
            <ng-container *ngFor="let row of listaVolumes; let i = index">
              <div class="selecao-header">
                <h5 class="m-0">
                  {{ row.pedido.pedidoId }}
                  <small
                    >- {{ row.pedido.volumes?.length }}
                    {{
                      row.pedido.volumes?.length > 1 ? "volumes" : "volume"
                    }}</small
                  >
                  <br />
                  <span style="color: var(--yellow)">{{
                    row.pedido.cliente
                  }}</span>
                </h5>
                <mat-chip-grid>
                  <mat-chip
                    color="accent"
                    *ngFor="let origin of row.origens"
                    [matTooltip]="'Localizado através do campo ' + origin"
                  >
                    {{ origin }}
                  </mat-chip>
                </mat-chip-grid>
              </div>
              <mat-divider></mat-divider>
              <mat-radio-group
                (change)="
                  hasManifestoTransf = !!$event.value.volumeSelecionado
                    .manifTransfID;
                  replaceManif = false
                "
                [(ngModel)]="volumeSelecionado"
              >
                <table mat-table [dataSource]="row.pedido.volumes" class="mb-4">
                  <ng-container matColumnDef="select">
                    <th mat-header-cell *matHeaderCellDef>Selecione</th>
                    <td mat-cell *matCellDef="let vol" data-label="Selecionar Este">
                      <mat-radio-button [value]="refVolumes[vol.pedEtiqueta]"></mat-radio-button>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="barCodeVol">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Código de Barra">
                        C.B. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="C.B."> {{vol.barCodeVol}} </td>
                  </ng-container>

                  <ng-container matColumnDef="etiqueta">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Etiqueta">
                       E. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="E."> {{vol.etiqueta}} </td>
                  </ng-container>

                  <ng-container matColumnDef="etiqueta2">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Etiqueta 2">
                        E.2 <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="E.2"> {{vol.etiqueta2}} </td>
                  </ng-container>

                  <ng-container matColumnDef="medidas">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Altura x Largura x Comprimento">
                        A.L.C <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="A.L.C.">
                      {{temMedidas(vol)}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="pesoPED">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Peso Bruto">
                        P.B. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="P.B."> {{vol.pesoPED | number}} </td>
                  </ng-container>

                  <ng-container matColumnDef="pesoOriginal">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Peso Bruto Original">
                        P.B.O. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="P.B.O."> {{vol.pesoOriginal | number}} </td>
                  </ng-container>

                  <ng-container matColumnDef="pesoCubado">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Peso Cubado">
                        P.C. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="P.C."> {{vol.pesoCubado | number}} </td>
                  </ng-container>

                  <ng-container matColumnDef="pesoCubadoOrig">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Peso Cubado Original">
                        P.C.O. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="P.C.O."> {{vol.pesoCubadoOrig | number}} </td>
                  </ng-container>

                  <ng-container matColumnDef="filialOrigem">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Filial Origem">
                        F.O. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="F.O."> {{vol.filialOrigem}} </td>
                  </ng-container>

                  <ng-container matColumnDef="filialDestino">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Filial Destino">
                        F.D. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="F.D."> {{vol.filialDestino}} </td>
                  </ng-container>

                  <ng-container matColumnDef="numeroCompletoManifesto">
                    <th mat-header-cell *matHeaderCellDef>
                      <span matTooltip="Número Manifesto">
                        N.M. <i class="fas fa-question-circle"></i>
                      </span>
                    </th>
                    <td mat-cell *matCellDef="let vol" data-label="N.M."> {{vol.numeroCompletoManifesto}} </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let vol; columns: displayedColumns"
                  ></tr>
                </table>
              </mat-radio-group>
            </ng-container>
          </div>
        </mat-tab>
        <mat-tab label="Pedidos encontrados" *ngIf="listaPedidos?.length">
          <div class="modal-content">
            <p class="lead">Selecione a NRT e prossiga para buscar os volumes:</p>
            <mat-radio-group [(ngModel)]="volumeSelecionado"
              (change)="hasManifestoTransf = !!$event.value.pedido.manifTransfID; replaceManif = false"
            >
              <table mat-table [dataSource]="listaPedidos" class="mb-4 mt-2">
                <!-- Checkbox Column -->
                <ng-container matColumnDef="select">
                  <th mat-header-cell *matHeaderCellDef>Selecione</th>
                  <td mat-cell *matCellDef="let row" data-label="Selecionar Este">
                    <mat-radio-button [value]="row"></mat-radio-button>
                  </td>
                </ng-container>

                <ng-container matColumnDef="pedidoId">
                  <th mat-header-cell *matHeaderCellDef> Pedido ID </th>
                  <td mat-cell *matCellDef="let element" data-label="Pedido ID"> {{element.pedido.pedidoId}} </td>
                </ng-container>

                <ng-container matColumnDef="origens">
                  <th mat-header-cell *matHeaderCellDef> Origens </th>
                  <td mat-cell *matCellDef="let element" data-label="Origens">
                    {{element.origens.join(', ')}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="cliente">
                  <th mat-header-cell *matHeaderCellDef> Cliente </th>
                  <td mat-cell *matCellDef="let element" data-label="Cliente"> {{element.pedido.cliente}} </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="['select', 'pedidoId', 'origens', 'cliente']"></tr>
                <tr mat-row *matRowDef="let row; columns: ['select', 'pedidoId', 'origens', 'cliente']"></tr>
              </table>
            </mat-radio-group>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
  <div mat-dialog-actions class="d-block">
    <mat-checkbox
      *ngIf="hasManifestoTransf && (tipo !== 5 && tipo !== 50)"
      class="float-left text-danger"
      color="warn"
      [(ngModel)]="replaceManif"
      >Este pedido já possui manifesto, deseja continuar?</mat-checkbox
    >
    <div class="float-right">
      <button
        mat-flat-button
        class="mx-1"
        [disabled]="isLoading"
        mat-dialog-close="cancel"
        color="info"
      >
        Cancelar
      </button>
      <button
        mat-flat-button
        class="mx-1"
        color="primary"
        (click)="gravarVolumes()"
        [disabled]="
          isLoading ||
          !volumeSelecionado ||
          (hasManifestoTransf && !replaceManif && (tipo !== 5 && tipo !== 50))
        "
      >
        Ok
      </button>
    </div>
  </div>
</div>
